// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1emk-","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2Sy1C"};